export default __webpack_public_path__ + "static/media/white_logo.602271bb.svg";